/**
 * Lazy load scripts.
 *
 * @module app/components/DeferredDependencies
 */
import DeferredDependenciesCom from './DeferredDependenciesCom';
import DeferredDependenciesNJ from './DeferredDependenciesNJ';
import constant from '../constants/config';
import _ from 'lodash';


/**
 * Get the correct deferredDependency file and initialise it
 *
 * @returns {void}
 *
 * @public
 */
var init = async function init() {
    var deferredDependencies;
    // Use a switch here!
    if (window.whStatic.config.jurisdiction === constant.newJerseyName) {
        deferredDependencies = DeferredDependenciesNJ;
    } else {
        deferredDependencies = DeferredDependenciesCom;
    }
    deferredDependencies.init();
};

/**
 * Public functions
 *
 * @type {Object}
 */
var api = {
    reInit: init,
    init: _.once(init),
};

export default api;
